<template>
  <div
    ref="reactions"
    class="position-relative reactions-area d-flex align-items-center"
    style="z-index: 9999"
    :class="{ disabled }"
  >
    <div
      id="reacts-btn"
      v-hammer:pan="panning"
      v-hammer:panend="panEnd"
      v-hammer:pressup="hide"
      v-hammer:press="show"
      class="reacts d-flex align-items-center"
      @mouseover="isHoveringOver"
      @mouseleave="isNotHoveringOver"
      @click="toggleReactionInstantly"
    >
      <div class="like-btn d-flex align-items-center">
        <slot />
      </div>
    </div>
    <div
      class="box"
      :class="reacting ? 'show' : ''"
      @mouseover="isHoveringOver"
      v-click-outside="close"
      v-if="isAuthenticated"
    >
      <input type="checkbox" id="like" class="field-reactions" />
      <label for="like" class="label-reactions"></label>
      <div
        v-click-outside="hideFromOutside"
        id="toolbox"
        class="toolbox"
        :class="index % 2 === 0 && isMobSmallScreen ? 'toolbox-even' : ''"
      >
        <div class="arrow"></div>
        <div class="arrow-border"></div>
        <div class="reactions-types p-1">
          <div
            class="reaction-type"
            v-for="(value, key, index) in visualReactionsNames"
            @click="react(key)"
            :key="index"
          >
            <div :class="[userReaction && key === userReaction.reaction ? 'count-selected' : 'count']">
              {{ reactionCount(key) }}
            </div>
            <div
              class="mt-1 clickable name"
              :class="[userReaction && key === userReaction.reaction ? 'name-selected' : '']"
            >
              {{ reactionName(key) }}
            </div>
          </div>
        </div>
      </div>
      <label class="overlay" for="like"> </label>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import { ReactionImageCounts, UserReaction } from '@/types/static-types';
import omit from 'lodash/omit';
import { visualReactionsNames } from '@/statics/reactions';
import { authStore } from '~/pinia-store/auth';

@Options({
  name: 'VisualReaction',
  components: {},
})
export default class VisualReaction extends Vue {
  @Prop({ default: false }) public disabled!: boolean;
  @Prop({ default: false }) public isMobSmallScreen!: boolean;
  @Prop({}) public index!: any;

  @Prop({ default: () => ({}) }) public reactions!: ReactionImageCounts;
  @Prop({ default: () => ({}) }) public userReaction!: UserReaction;
  @Prop({ default: false, required: false }) public leftIndentPopup!: boolean;

  public get isAuthenticated() {
    const { isAuthenticated } = authStore()
    return isAuthenticated.value
  }

  public iconsReactions: any[] = [];
  public hoveredReactionIndex = 999;
  public isPanning = false;
  public reacting = false;
  public working = false;
  public isHovering = false;

  public visualReactionsNames = visualReactionsNames;

  public reactionName(key: string): string {
    return visualReactionsNames[key];
  }

  public hideFromOutside(e: any) {
    const elId = e.target.id;
    if (elId !== 'reacts-btn') {
      this.setReacting(false);
    }
  }

  public reactionCount(key: string): number {
    return this.reactionsMap[key] || 0;
  }

  public get reactionsMap(): { [key: string]: number } {
    const reactions = omit({ ...this.reactions }, ['total_count', 'ordering']);
    return reactions as { [key: string]: number };
  }

  public isHoveringOver() {
    this.isHovering = true;
    setTimeout(() => {
      if (this.isHovering) this.setReacting(true);
    }, 250);
  }

  @Emit('changed')
  public react(key: string) {
    this.setReacting(false);
    return key;
  }

  public isNotHoveringOver() {
    this.isHovering = false;
    setTimeout(() => {
      if (!this.isHovering) this.setReacting(false);
    }, 1500);
  }

  public getCurrentHoveredIndex(positionX: number) {
    const reactionsArea = this.$refs.reactions as any;
    const leftShifter = reactionsArea.offsetLeft;
    const boundaries = [
      {
        start: 0,
        end: 50,
      },
      {
        start: 50,
        end: 100,
      },
      {
        start: 100,
        end: 150,
      },
      {
        start: 150,
        end: 200,
      },
      {
        start: 200,
        end: 250,
      },
    ];
    if (positionX > leftShifter + 250) return 999;
    const index = boundaries.findIndex(
      (item) => positionX > leftShifter + item.start && positionX < leftShifter + item.end
    );
    if (index < 0) return 999;
    return index;
  }

  public panEnd() {
    if (this.hoveredReactionIndex < 999) {
      this.hoveredReactionIndex = 999;
    } else {
      this.close();
    }
  }

  public panning() {
    this.isPanning = true;
  }

  public close(event?: any) {
    if (event) {
      const elId = event.target?.id;
      if (elId === 'toolbox') {
        return;
      }
    }
    this.setReacting(false);
  }

  public show() {
    this.isPanning = false;
    this.setReacting(true);
  }

  public hide() {
    setTimeout(
      () => {
        this.setReacting(false);
      },
      this.isPanning ? 250 : 1500
    );
  }

  public setReacting(value: any) {
    this.reacting = value;
    return;
  }
}
</script>

<style scoped lang="sass">
.disabled
  pointer-events: none
.reactions-types
  width: 100% !important
  height: 133px !important
  overflow: auto
  scrollbar-width: none
  display: flex
  flex-wrap: wrap
  &::-webkit-scrollbar
    display: none
  .reaction-type
    color: #7f10b3 !important
    width: 50% !important
    position: relative !important
    text-align: center
  .count
    height: 25px
    font-size: 20px
    color: #7f10b3 !important
    user-select: none !important

  .count-selected
    height: 25px
    font-size: 20px
    color: #3dc2ff !important
    user-select: none !important

  .name
    background-color: #7f10b3
    color: #FFF
    border-radius: 13px
    height: 35px
    align-items: center
    justify-content: center
    display: flex
    font-size: 14px

  .name-selected
    background-color: #3dc2ff
    color: #FFF !important

.like-btn
  color: #214163 !important
  overflow: auto !important
  .icon
    color: #214163 !important
.reaction-selection
  background-size: cover
.reactions-area
  .bluer
    color: #214163 !important
    &.reacted
      color: #ae38e5 !important
      border-radius: 5px
      background-color: rgb(193, 247, 247) !important
      padding: 0 10px
      line-height: 22px
.reacts
  user-select: none !important
  font-size: 16px
.one-react
  font-size: 15px
  display: flex
  align-items: center
  img
    min-width: 15px
    width: 15px
    height: 15px
  &:not(:first-child)
    margin-left: -5px
*
  color: #FFF !important
.reaction
  display: inline-block
  margin: 0px

%hidden
  clip: rect(1px, 1px, 1px, 1px)
  overflow: hidden
  position: absolute
  top: 0
  left: 0

%show
  clip: auto
  overflow: visible
  opacity: 1

.main-title
  padding: 10px
  color: #fff
  text-align: center
  font-size: 16px
  text-shadow: 1px 1px 3px rgba(0,0,0,.3)

.text-desc
  @extend %hidden
  font-weight: normal
  text-align: center
  transform: translateY(-50px)
  white-space: nowrap
  font-size: 13px
  width: 100%

[class*="reaction-"]
  @extend %hidden
  border: none
  background-color: transparent
  display: block
  position: absolute
  width: 48px
  z-index: 11
  top: 30px
  transform-origin: 50% 100%
  transform: scale(.1)
  transition: all .3s ease
  outline: none
  will-change: transform
  opacity: 0

.box
  position: absolute
  left: calc(50% - 40px)
  top: calc(50% - 44px)
  width: 250px

.overlay
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  z-index: 9
  visibility: hidden

.field-reactions
  @extend %hidden

  &:focus
    ~ .label-reactions
      border-color: rgba(88,144,255,.3)

    ~ .text-desc
      @extend %show

  &:checked:focus
    ~ .label-reactions
      border-color: transparent

    ~ .text-desc
      @extend %hidden

.label-reactions
  position: absolute
  background: transparent
  color: Transparent !important
  display: block
  height: 0px
  margin: 15px auto 0 0
  width: 0px
  color: transparent
  cursor: pointer

.toolbox-left-ind
  left: -21px !important
  .arrow
    left: 40px !important
  .arrow-border
    left: 40px !important

.toolbox
  position: relative
  background: #fff
  height: 140px
  box-shadow: 0 2px 13px rgba(0, 0, 0, .15)
  border: 2px solid #ae38e5
  box-sizing: border-box
  width: 280px
  border-radius: 20px
  top: -120px
  left: 1px
  position: absolute
  visibility: hidden
  opacity: 0
  transition: opacity .15s
  z-index: 11
  .arrow
    position: absolute
    width: 0
    height: 0
    border-left: 12px solid transparent
    border-right: 12px solid transparent
    border-top: 12px solid #FFF
    top: 135px
    left: 14px
    z-index: 12
  .arrow-border
    position: absolute
    width: 0
    height: 0
    border-left: 12px solid transparent
    border-right: 12px solid transparent
    border-top: 12px solid #ae38e5
    z-index: 1
    top: 137px
    left: 14px

.toolbox-even
  left: -84px
  .arrow
    left: 108px
    @media(max-width: 350px)
      left: 108px
  .arrow-border
    left: 108px
    @media(max-width: 350px)
      left: 108px

.legend-reaction
  background: rgba(0, 198, 198, .75)
  border-radius: 10px
  box-sizing: border-box
  color: #fff
  display: inline-block
  font-size: 11px
  text-overflow: ellipsis
  font-weight: bold
  line-height: 20px
  max-width: 100%
  min-width: 60px
  opacity: 0
  overflow: hidden
  padding: 0 6px
  transition: opacity 50ms ease
  left: 50%
  position: absolute
  text-align: center
  top: -28px
  transform: translateX(-50%)

.reaction-selection
  &.is-hovered
    transform: scale(1) translateY(-35px) !important
    .legend-reaction
      opacity: 1

.box.show

  [class*="reaction-"]
    transform: scale(.85) translateY(-40px)
    @extend %show

    // &:active,
    // &:focus,
    //   // transition: all 0.2s ease-in
    //   // transform: scale(1) translateY(-35px)
    //   .legend-reaction
    //     opacity: 1

  .toolbox
    opacity: 1
  .toolbox-even
    opacity: 1

  .toolbox
    visibility: visible
  .toolbox-even
    visibility: visible

  .reaction-love
    transition-delay: .06s

  .reaction-haha
    transition-delay: .09s

  .reaction-wow
    transition-delay: .12s

  .reaction-sad
    transition-delay: .15s

  .reaction-angry
    transition-delay: .18s

.field-reactions:checked

  ~ [class*="reaction-"]
    transform: scale(.85) translateY(-40px)
    @extend %show

    &:active,
    &:focus
      transition: all 0.2s ease-in
      transform: scale(1) translateY(-35px)

      .legend-reaction
        opacity: 1

  ~ .toolbox,
  ~ .toolbox-even,
  ~ .overlay
    visibility: visible

  ~ .reaction-love
    transition-delay: .03s

  ~ .reaction-haha
    transition-delay: .09s

  ~ .reaction-wow
    transition-delay: .12s

  ~ .reaction-sad
    transition-delay: .15s

  ~ .reaction-angry
    transition-delay: .18s

.reaction-like
  left: 0

.reaction-love
  left: 50px

.reaction-haha
  left: 100px

.reaction-wow
  left: 150px

.reaction-sad
  left: 200px

.reaction-angry
  left: 250px

@media (max-width: 350px)
  .toolbox
    left: 15px !important

.clickable
  cursor: pointer
.clickable:hover
  opacity: 0.7
</style>
